import { useState, useCallback } from "react";
import axios from "axios";
import { LeadDto } from "../../../../types/Leads.types";

interface UseCreateLeadResult {
  createLead: (payload: LeadDto) => Promise<void>;
  loading: boolean;
  error: string | null;
  success: boolean;
}

export const useCreateLead = (): UseCreateLeadResult => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  const createLead = useCallback(async (payload: LeadDto) => {
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      const response = await axios.post("/api/lead", payload, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (response.status >= 200 && response.status < 300) {
        setSuccess(true);
      } else {
        throw new Error("Erro inesperado ao criar lead.");
      }
    } catch (err: any) {
      console.error("Erro ao criar lead:", err);
      setError(
        err.response?.data?.error || err.message || "Erro desconhecido."
      );
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    createLead,
    loading,
    error,
    success,
  };
};
